import GameAPi from '../../api/game-occurence-api'

export default {
    namespaced: true,
    state: {
      token: "",
      apiMessage: "",
    },
    getters: {
      token: state => {
        if(state.token === ""){
           let token = localStorage.getItem('adminToken');
           if(token){
             state.token = token
           }
        }
        return state.token;
      }
    },
    mutations: {
      updateAdminToken(state, token) {
         state.token = token;
         localStorage.setItem('adminToken', token);
      },
      updateApiMessage(state, message) {
        state.apiMessage = message;
      }
    },
    actions: {
      async logIn({
        commit
      }, user) {
        let response = await GameAPi.logInAdmin(user.username, user.password);
  
        if (response.valid) {
          commit('updateAdminToken', response.token);
        } else {
          commit('updateApiMessage', response.message);
        }
      }
    }
  }